<template>
  <div class="main user-layout-register" style="width:500px;margin-left: -100px;">
    <h3><span style="font-weight: bolder">用户申请</span></h3>
    <a-form-model ref="form" :model="model" :rules="validatorRules">
      <a-row style="width: 100%;">
        <a-form-model-item label="用户账号" prop="username" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="model.username" type="text" autocomplete="false" placeholder="请输入用户账号" :maxLength="maxLength"/>
        </a-form-model-item>
        <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
          <template slot="content">
            <div :style="{ width: '240px' }">
              <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
              <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor "/>
              <div style="margin-top: 10px;">
                <span>请至少输入 8 个字母、数字或特殊字符。请不要使用容易被猜到的密码。</span>
              </div>
            </div>
          </template>
          <a-form-model-item prop="password" label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-password
              v-model="model.password"
              type="password"
              @click="handlePasswordInputClick"
              autocomplete="false"
              :maxLength="maxLength"
              placeholder="至少8位密码，区分大小写">
            </a-input-password>
          </a-form-model-item>
        </a-popover>

        <a-form-model-item prop="password2" label="再次输入密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password v-model="model.password2" type="password" autocomplete="false"
                   placeholder="确认密码" :maxLength="maxLength"></a-input-password>
        </a-form-model-item>

        <a-form-model-item prop="realname" label="真实姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入真实姓名" v-model="model.realname" :readOnly="!!model.id" :maxLength="maxLength"/>
        </a-form-model-item>

        <a-form-model-item label="工号" prop="workNo" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入工号" v-model="model.workNo" :maxLength="maxLength"/>
        </a-form-model-item>

        <!--部门分配-->
        <a-form-model-item label="部门分配" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="selectedDeparts">
          <j-select-depart v-model="model.selectedDeparts" :multi="true" @back="backDepartInfo" :backDepart="true" :treeOpera="true"></j-select-depart>
        </a-form-model-item>

        <a-form-model-item label="申请使用应用" prop="selectedApplications" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-multi-select-tag
            :disabled="disableSubmit"
            v-model="model.selectedApplications"
            :options="applicationOptions"
            placeholder="请选择应用">
          </j-multi-select-tag>
        </a-form-model-item>

        <a-form-model-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload class="avatar-uploader" text="上传" v-model="model.avatar"></j-image-upload>
        </a-form-model-item>

        <a-form-model-item label="生日" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            placeholder="请选择生日"
            v-model="model.birthday"
            :disabled-date="disabledDate"
            :format="dateFormat"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-model-item>

        <a-form-model-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-model="model.sex" placeholder="请选择性别" :getPopupContainer="(target) => target.parentNode">
            <a-select-option :value="1">男</a-select-option>
            <a-select-option :value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="邮箱"  prop="email" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入邮箱" v-model="model.email" :maxLength="maxLength"/>
        </a-form-model-item>

        <a-form-model-item label="手机号码"  prop="phone" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入手机号码" v-model="model.phone" :maxLength="maxLength"/>
        </a-form-model-item>

        <a-form-model-item label="座机"  prop="telephone" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入座机" v-model="model.telephone" :maxLength="maxLength"/>
        </a-form-model-item>

        <a-form-model-item>
          <a-button
            size="large"
            type="primary"
            htmlType="submit"
            class="register-button"
            :loading="registerBtn"
            @click.stop.prevent="handleSubmit"
            :disabled="registerBtn">提交申请
          </a-button>
          <router-link class="login" :to="{ name: 'login' }">使用已有账户登录</router-link>
        </a-form-model-item>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
  import {mixinDevice} from '@/utils/mixin.js'
  import {getSmsCaptcha} from '@/api/login'
  import {postAction,getAction} from '@/api/manage'
  import moment from 'moment'
  import { checkOnlyUser,duplicateCheck,applicationList } from '@/api/api'

  const levelNames = {
    0: '低',
    1: '低',
    2: '中',
    3: '强'
  }
  const levelClass = {
    0: 'error',
    1: 'error',
    2: 'warning',
    3: 'success'
  }
  const levelColor = {
    0: '#ff0000',
    1: '#ff0000',
    2: '#ff7e05',
    3: '#52c41a',
  }
  export default {
    name: "Register",
    components: {},
    mixins: [mixinDevice],
    data() {
      return {
        model: {},
        maxLength:40,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        dateFormat:"YYYY-MM-DD",
        disableSubmit:false,
        selectedApplications:'',
        selectedDeparts:'',
        applicationOptions:[],
        nextDepartOptions:[],
        validatorRules: {
          username: [
            {required: true, message:"请输入用户名!"},
            {validator: this.checkUsername}
          ],
          realname: [
            {required: true, message:"请输入真实姓名!"},
          ],
          selectedDeparts: [
            {required: true, message:"请选择部门!"},
          ],
          password: [
            {required: true, message:"请输入密码!"},
            {validator: this.handlePasswordLevel}
          ],
          password2: [
            {required: true, message:"请输入确认密码!"},
            {validator: this.handlePasswordCheck}
          ],
          phone: [
            {required: true, message: '请输入手机号!'},
            {validator: this.validatePhone}
          ],
          captcha: [
            {required: false},
            {validator: this.handleCaptchaCheck}
          ],
          email: [
            {required: true, message: '请输入邮箱!'},
            {validator: this.validateEmail}
          ],
          workNo: [
            {required: true, message: '请输入工号!'},
            {validator: this.validateWorkNo}
          ],
          selectedApplications: [
            {required: true, message: '请选择应用!'},
          ],
          telephone: [
            { pattern: /^\d{3,4}-[1-9]\d{3,9}$/, message: '请输入正确的座机号码' },
          ]
        },
        state: {
          time: 60,
          smsSendBtn: false,
          passwordLevel: 0,
          passwordLevelChecked: false,
          percent: 10,
          progressColor: '#FF0000'
        },
        registerBtn: false,
        url: {
          checkUsernameAndWorkNoDuplicate: '/sys/sysUserApply/checkUsernameAndWorkNoDuplicate',
        },
      }
    },
    created() {
      this.initApplicationList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      passwordLevelClass() {
        return levelClass[this.state.passwordLevel]
      },
      passwordLevelName() {
        return levelNames[this.state.passwordLevel]
      },
      passwordLevelColor() {
        return levelColor[this.state.passwordLevel]
      }
    },
    methods: {
      disabledDate(current) {
        return current && current > moment().endOf('day');
      },
      beforeUpload: function(file){
        var fileType = file.type;
        if(fileType.indexOf('image')<0){
          this.$message.warning('请上传图片');
          return false;
        }
        //TODO 验证文件大小
      },
      initApplicationList(){
        applicationList().then((res) => {
          if(res.success){
            this.applicationOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selectedDeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      checkUsername(rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else {
          let that = this;
          let params = {
            username: value
          };
          getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
            if (res.success) {
              callback()
            } else {
              callback("用户名已存在!")
            }
          })
        }
        /*let params = {
          username: value,
        };
        checkOnlyUser(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback("用户名已存在!")
          }
        })*/
      },
      validateWorkNo(rule, value, callback){
        let that = this;
        let params = {
          workNo: value
        };
        getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
          if (res.success) {
            callback()
          } else {
            callback("工号已存在!")
          }
        })
      },
      validateEmail(rule, value, callback){
        let that = this;
        if(!value){
          callback()
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            let params = {
              email: value
            };
            getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
              if (res.success) {
                callback()
              } else {
                callback("邮箱已存在!")
              }
            })
          }else{
            callback("请输入正确格式的邮箱!")
          }
        }
      },

      handlePasswordLevel(rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else {
          let level = 0
          let reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;
          if (!reg.test(value)) {
            callback(new Error('密码由8位数字、大小写字母和特殊符号组成!'))
          }
          // 判断这个字符串中有没有数字
          if (/[0-9]/.test(value)) {
            level++
          }
          // 判断字符串中有没有字母
          if (/[a-zA-Z]/.test(value)) {
            level++
          }
          // 判断字符串中有没有特殊符号
          if (/[^0-9a-zA-Z_]/.test(value)) {
            level++
          }
          this.state.passwordLevel = level
          this.state.percent = level * 30
          if (level >= 2) {
            if (level >= 3) {
              this.state.percent = 100
            }
            callback()
          } else {
            if (level === 0) {
              this.state.percent = 10
            }
            callback(new Error('密码强度不够'))
          }
        }
      },

      handlePasswordCheck(rule, value, callback) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入汉字!'));
        } else {
          let password = this.model['password']
          //console.log('value', value)
          if (value === undefined) {
            callback(new Error('请输入密码'))
          }
          if (value && password && value.trim() !== password.trim()) {
            callback(new Error('两次密码不一致'))
          }
          callback()
        }
      },
      handleCaptchaCheck(rule, value, callback) {
        if (!value) {
          callback(new Error("请输入验证码"))
        } else {
          callback();
        }
      },
      validatePhone(rule, value, callback){
        let that = this;
        // if(!value){
        //   callback()
        // }else{
          if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)){
            let params = {
              phone: value
            };
            getAction(that.url.checkUsernameAndWorkNoDuplicate, params).then((res)=>{
              if (res.success) {
                callback()
              } else {
                callback("手机号已存在!")
              }
            })
            /*var params = {
              tableName: 'sys_user',
              fieldName: 'phone',
              fieldVal: value,
              dataId: this.userId
            };
            duplicateCheck(params).then((res) => {
              if (res.success) {
                callback()
              } else {
                callback("手机号已存在!")
              }
            })*/
          }else{
            callback("请输入正确格式的手机号码!");
          }
        // }
      },

      handlePasswordInputClick() {
        if (!this.isMobile()) {
          this.state.passwordLevelChecked = true
          return;
        }
        this.state.passwordLevelChecked = false
      },

      handleSubmit() {
        this.$refs['form'].validate((success) => {
          if (success == true) {
            let values = this.model
            postAction("/sys/sysUserApply/add", values).then((res) => {
              if (!res.success) {
                this.registerFailed(res.message)
              } else {
                this.$router.push({name: 'registerResult', params: {...values}})
              }
            })
          }
        })
      },
      registerFailed(message) {
        this.$notification['error']({
          message: "注册失败",
          description: message,
          duration: 2,
        });

      },
      requestFailed(err) {
        this.$notification['error']({
          message: '错误',
          description: ((err.response || {}).data || {}).message || "请求出现错误，请稍后再试",
          duration: 4,
        });
        this.registerBtn = false;
      },
    },
    watch: {
      'state.passwordLevel'(val) {
        console.log(val)

      }
    }
  }
</script>
<style lang="less">
  .user-register {

    &.error {
      color: #ff0000;
    }

    &.warning {
      color: #ff7e05;
    }

    &.success {
      color: #52c41a;
    }

  }

  .user-layout-register {
    /*background-color: #ffffff;*/
    /*padding: 20px;*/
    .ant-input-group-addon:first-child {
      background-color: #fff;
    }
  }
</style>
<style lang="less" scoped>
  .user-layout-register {

    & > h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

    .register-button {
      width: 50%;
      margin-top: 20px;
    }

    .login {
      float: right;
      line-height: 40px;
      margin-top: 20px;
    }
  }

  .main{
    min-width: 260px!important;
    width: 500px!important;
  }

  #userLayout.user-layout-wrapper .container .main {
    min-width: 260px!important;
    width: 500px!important;
    margin: 0 auto;
  }
  .user-layout-wrapper {
    &.mobile {
      .container {
        .main {
          max-width: 500px;
          width: 98%;
        }
      }
    }
  }
  .ant-form-item {
    margin-bottom: 15px !important;
  }
</style>